// PARAQTA — Каталог v2 (Опус 4.7 дизайн, Stage 6.2).
//
// loadCatalog() — entry point (router-дан шақырылады). Жаңа дизайн HTML-ді
// (#pg-catalog v2) data-field/data-section атрибуттары арқылы толтырады.
//
// loadGenres / filterGenre / catalogGoPage / setCatalogGenre — legacy
// exports (landing/events әлі шақыруы мүмкін). Жаңа v2 DOM-да олардың
// targets-тары жоқ — safe no-ops.

import { api } from '../../core/api.js';
import { show } from '../../core/router.js';
import { esc } from '../../utils/format.js';

// Шыншыл белгі — кітапхана мәтіні жоқ анықтамалық болғандықтан, қайсысын
// САЙТТА оқуға болатынын алдын ала көрсетеміз. Оқылатыны — жасыл.
function readTag(reader) {
  return reader
    ? '<div class="cat-rtag ok">📖 мұнда оқисың</div>'
    : '<div class="cat-rtag">✍️ өз кітабыңнан</div>';   // 25.09: «бет санағыш» түсініксіз еді
}
import { toast } from '../../utils/toast.js';
import { openBookPage } from '../book-page/index.js';

const $ = (sel, r = document) => r.querySelector(sel);
const $$ = (sel, r = document) => Array.from(r.querySelectorAll(sel));
const root = () => document.getElementById('pg-catalog');
const genreRoot = () => document.getElementById('pg-genre');
const authorRoot = () => document.getElementById('pg-author');

// ── Genre style mapping (slug-based, замена palette-index approach) ──
// Founder approve: name-based mapping, palette ретімен emес.
const GENRE_STYLE_MAP = {
  'korkem':           { icon_ti: 'ti-feather',     bg: 'linear-gradient(135deg, color-mix(in srgb, var(--ac) 12%, transparent), color-mix(in srgb, var(--ac) 4%, transparent))',   border: 'color-mix(in srgb, var(--ac) 20%, transparent)',   icon_color: '#8B5E34' },
  'tarih':            { icon_ti: 'ti-history',     bg: 'linear-gradient(135deg, color-mix(in srgb, var(--gold) 15%, transparent), color-mix(in srgb, var(--ac) 4%, transparent))', border: 'color-mix(in srgb, var(--gold) 30%, transparent)', icon_color: '#8B5E34' },
  'ozin-ozi':         { icon_ti: 'ti-target',      bg: 'linear-gradient(135deg, rgba(168,85,247,0.08), rgba(168,85,247,0.02))', border: 'rgba(168,85,247,0.2)',  icon_color: '#a855f7' },
  'biznes':           { icon_ti: 'ti-briefcase',   bg: 'linear-gradient(135deg, color-mix(in srgb, var(--ink) 6%, transparent), color-mix(in srgb, var(--ink) 2%, transparent))',     border: 'color-mix(in srgb, var(--ink) 15%, transparent)',   icon_color: '#1C1A16' },
  'dini':             { icon_ti: 'ti-book-2',      bg: 'linear-gradient(135deg, color-mix(in srgb, var(--gold) 12%, transparent), color-mix(in srgb, var(--gold) 4%, transparent))', border: 'color-mix(in srgb, var(--gold) 25%, transparent)', icon_color: '#C9A96E' },
  'psihologiya':      { icon_ti: 'ti-brain',       bg: 'linear-gradient(135deg, color-mix(in srgb, var(--gn) 10%, transparent), color-mix(in srgb, var(--gn) 2%, transparent))',      border: 'color-mix(in srgb, var(--gn) 20%, transparent)',    icon_color: '#3A5C3C' },
  'balalar':          { icon_ti: 'ti-mood-smile',  bg: 'linear-gradient(135deg, rgba(234,88,12,0.08), rgba(234,88,12,0.02))',   border: 'rgba(234,88,12,0.18)',  icon_color: '#ea580c' },
  'mahabbat-romany':  { icon_ti: 'ti-heart',       bg: 'linear-gradient(135deg, rgba(244,63,94,0.08), rgba(244,63,94,0.02))',   border: 'rgba(244,63,94,0.2)',   icon_color: '#f43f5e' },
  'shetel':           { icon_ti: 'ti-language',    bg: 'linear-gradient(135deg, rgba(14,165,233,0.08), rgba(14,165,233,0.02))', border: 'rgba(14,165,233,0.2)',  icon_color: '#0ea5e9' },
  'filosofiya':       { icon_ti: 'ti-bulb',        bg: 'linear-gradient(135deg, rgba(75,85,99,0.08), rgba(75,85,99,0.02))',     border: 'rgba(75,85,99,0.18)',   icon_color: '#4b5563' },
  'gylymi':           { icon_ti: 'ti-atom',        bg: 'linear-gradient(135deg, rgba(6,182,212,0.08), rgba(6,182,212,0.02))',   border: 'rgba(6,182,212,0.18)',  icon_color: '#06b6d4' },
  'otbasylyk':        { icon_ti: 'ti-users',       bg: 'linear-gradient(135deg, rgba(180,83,9,0.08), rgba(180,83,9,0.02))',     border: 'rgba(180,83,9,0.18)',   icon_color: '#b45309' },
};
const GENRE_STYLE_DEFAULT = {
  icon_ti: 'ti-book',
  bg: 'linear-gradient(135deg, color-mix(in srgb, var(--ac) 8%, transparent), color-mix(in srgb, var(--ac) 2%, transparent))',
  border: 'color-mix(in srgb, var(--ac) 18%, transparent)',
  icon_color: '#8B5E34',
};
function getGenreStyle(slug) {
  return GENRE_STYLE_MAP[slug] || GENRE_STYLE_DEFAULT;
}

const state = {
  data: null,
  searchTimer: null,
  searchActive: false,
  // Stage 6.3: жанр/автор pagination state
  genre: { slug: null, sort: 'popular', offset: 0, books: [] },
  author: { slug: null },
};

function setField(name, value) {
  const el = $(`[data-field="${name}"]`, root());
  if (el) el.textContent = value;
}

function fmtNum(n) {
  return (Number(n) || 0).toLocaleString('kk-KZ').replace(/,/g, ' ');
}

// ── Render ──────────────────────────────────────────────────
function renderHero(data) {
  setField('catalog-count', fmtNum(data.total_count || 0));
  setField('new-count', data.new_week_count || 0);
  setField('new-week-count', data.new_week_count || 0);
}

function renderGenres(data) {
  const grid = $('[data-field="genres-grid"]', root());
  if (!grid) return;
  const genres = Array.isArray(data.genres) ? data.genres : [];
  grid.innerHTML = '';
  genres.forEach(g => {
    const style = getGenreStyle(g.slug);
    const btn = document.createElement('button');
    btn.dataset.action = 'open-genre';
    btn.dataset.genre = g.slug;
    // Stage 8 v2: жанр = чип (грид-тайл орнына) — жеңіл, жылы, мокап дизайны
    btn.style.cssText = 'flex: 0 0 auto; display: inline-flex; align-items: center; gap: 7px; padding: 9px 15px; background: var(--card); border: 0.5px solid color-mix(in srgb, var(--ink) 10%, transparent); border-radius: 999px; cursor: pointer; font-family: inherit; box-shadow: 0 2px 10px -7px rgba(28,26,22,.35);';
    btn.innerHTML = `
      <i class="ti ${esc(style.icon_ti)}" style="font-size: 15px; color: ${esc(style.icon_color)};"></i>
      <span style="font-size: 13px; font-weight: 600; color: var(--ink);">${esc(g.name || g.slug)}</span>
      <span style="font-size: 11px; color: color-mix(in srgb, var(--ink) 42%, transparent);">${fmtNum(g.count || 0)}</span>
    `;
    grid.appendChild(btn);
  });
}

function renderAuthors(data) {
  const list = $('[data-field="authors-list"]', root());
  if (!list) return;
  const authors = Array.isArray(data.popular_authors) ? data.popular_authors : [];
  list.innerHTML = '';
  authors.forEach(a => {
    const btn = document.createElement('button');
    btn.dataset.action = 'open-author';
    btn.dataset.author = a.slug;
    btn.style.cssText = 'flex: 0 0 120px; background: var(--card); border-radius: 14px; padding: 14px 12px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); cursor: pointer; text-align: center;';
    btn.innerHTML = `
      <div style="width: 54px; height: 54px; border-radius: 50%; background: ${esc(a.color_gradient)}; color: var(--bg); display: flex; align-items: center; justify-content: center; font-family: Georgia, serif; font-size: 18px; font-weight: 500; margin: 0 auto 8px;">${esc(a.initials || '?')}</div>
      <div style="font-family: Georgia, serif; font-size: 12px; font-weight: 500; line-height: 1.2; margin-bottom: 2px;">${esc(a.name || '')}</div>
      <div style="font-size: 10px; opacity: 0.55;">${a.books_count || 0} кітап</div>
    `;
    list.appendChild(btn);
  });
}

function renderFeatured(data) {
  const list = $('[data-field="featured-list"]', root());
  if (!list) return;
  const books = Array.isArray(data.featured_books) ? data.featured_books : [];
  list.innerHTML = '';
  books.forEach(b => {
    const btn = document.createElement('button');
    if (b.slug) {
      btn.dataset.action = 'open-book';
      btn.dataset.slug = b.slug;
    }
    btn.dataset.bookId = b.book_id ?? '';
    // Stage 8 v2: мұқаба-форвард карта (горизонталь свайп) — мокап дизайны
    btn.style.cssText = 'flex: 0 0 118px; width: 118px; background: none; border: none; padding: 0; cursor: pointer; text-align: left;';
    let badge = '';
    if (b.badge_type === 'streak' && b.readers_count) {
      badge = `🕯 ${b.readers_count} оқырман`;
    } else if (b.readers_count) {
      badge = `${b.readers_count} оқырман`;
    }
    btn.innerHTML = `
      <div style="width: 118px; height: 170px; background: ${esc(b.cover_gradient || 'linear-gradient(135deg, #8B5E34 0%, #6B4423 100%)')}; border-radius: 9px; position: relative; overflow: hidden; box-shadow: 0 8px 20px -10px rgba(28,26,22,.45); display: flex; align-items: center; justify-content: center; padding: 10px;">
        <div style="font-family: Georgia, serif; font-style: italic; font-size: 13px; color: #F3E9D6; text-align: center; line-height: 1.2; text-shadow: 0 1px 3px rgba(0,0,0,.25);">${esc(b.cover_text || b.title || '')}</div>
      </div>
      <div style="font-family: Georgia, serif; font-size: 13.5px; font-weight: 500; margin-top: 8px; line-height: 1.15; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(b.title || '—')}</div>
      <div style="font-size: 11px; opacity: 0.6; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(b.author || '')}</div>
      ${readTag(b.reader)}
      ${badge ? `<div style="font-size: 10.5px; color: var(--ac); font-weight: 600; margin-top: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${badge}</div>` : ''}
    `;
    list.appendChild(btn);
  });
  // Бос болса — placeholder
  if (books.length === 0) {
    list.innerHTML = '<div style="padding: 14px 16px; background: color-mix(in srgb, var(--ink) 2%, transparent); border-radius: 12px; border: 0.5px dashed color-mix(in srgb, var(--ink) 8%, transparent); text-align: center; font-size: 11px; opacity: 0.55;">Бұл аптада әзірге танымал кітап жоқ.</div>';
  }
}

function renderNewBooks(data) {
  const list = $('[data-field="new-list"]', root());
  if (!list) return;
  const books = Array.isArray(data.new_books) ? data.new_books : [];
  list.innerHTML = '';
  books.forEach(b => {
    const btn = document.createElement('button');
    if (b.slug) {
      btn.dataset.action = 'open-book';
      btn.dataset.slug = b.slug;
    }
    btn.dataset.bookId = b.book_id ?? '';
    btn.style.cssText = 'display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: var(--card); border-radius: 12px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); cursor: pointer; text-align: left; width: 100%;';
    btn.innerHTML = `
      <div style="width: 36px; height: 52px; background: ${esc(b.cover_gradient || 'linear-gradient(135deg, #4A1E15 0%, #2E0A00 100%)')}; border-radius: 3px; flex-shrink: 0; position: relative; overflow: hidden;">
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-family: Georgia, serif; font-size: 6px; font-style: italic; color: var(--bg);">${esc(b.cover_text || 'Жаңа')}</div>
      </div>
      <div style="flex: 1; min-width: 0;">
        <div style="font-family: Georgia, serif; font-size: 13px; font-weight: 500; line-height: 1.2; margin-bottom: 1px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(b.title || '—')}</div>
        <div style="font-size: 10px; opacity: 0.55; margin-bottom: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(b.author || '')}</div>
        <div style="font-size: 9px; opacity: 0.45;">${esc(b.added_ago || '')}</div>
      </div>
      <i class="ti ti-chevron-right" style="font-size: 14px; opacity: 0.3; flex-shrink: 0;"></i>
    `;
    list.appendChild(btn);
  });
  if (books.length === 0) {
    list.innerHTML = '<div style="padding: 12px 14px; background: color-mix(in srgb, var(--ink) 2%, transparent); border-radius: 12px; border: 0.5px dashed color-mix(in srgb, var(--ink) 8%, transparent); text-align: center; font-size: 11px; opacity: 0.55;">Соңғы 7 күнде жаңа кітап жоқ.</div>';
  }
}

// ── Search (type-ahead) ─────────────────────────────────────
function setupSearch() {
  const input = $('[data-field="catalog-search-input"]', root());
  const clearBtn = $('[data-action="catalog-search-clear"]', root());
  if (!input || input.dataset.bound) return;
  input.dataset.bound = '1';

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearBtn.style.display = q ? '' : 'none';
    if (state.searchTimer) clearTimeout(state.searchTimer);
    if (q.length < 2) {
      hideSearchResults();
      return;
    }
    state.searchTimer = setTimeout(() => runSearch(q), 300);
  });
}

async function runSearch(q) {
  if (state.searchActive) return;
  state.searchActive = true;
  try {
    const data = await api(`/api/catalog/search?q=${encodeURIComponent(q)}`);
    renderSearchResults(data);
  } catch (e) {
    console.warn('catalog search failed', e);
  } finally {
    state.searchActive = false;
  }
}

function renderSearchResults(data) {
  const box = $('[data-field="catalog-search-results"]', root());
  if (!box) return;
  const results = Array.isArray(data?.results) ? data.results : [];
  if (results.length === 0) {
    box.innerHTML = '<div style="padding: 14px; text-align: center; font-size: 11px; opacity: 0.55;">Нәтиже табылмады</div>';
    box.style.display = '';
    return;
  }
  box.innerHTML = '';
  results.forEach(r => {
    const item = document.createElement('button');
    if (r.slug) {
      item.dataset.action = 'open-book';
      item.dataset.slug = r.slug;
    }
    item.style.cssText = 'display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: none; border: none; border-bottom: 0.5px solid color-mix(in srgb, var(--ink) 5%, transparent); width: 100%; text-align: left; cursor: pointer;';
    item.innerHTML = `
      <i class="ti ti-book-2" style="font-size: 14px; color: var(--ac); opacity: 0.55; flex-shrink: 0;"></i>
      <div style="flex: 1; min-width: 0;">
        <div style="font-family: Georgia, serif; font-size: 13px; font-weight: 500; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(r.title || '')}</div>
        <div style="font-size: 10px; opacity: 0.55; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(r.author || '')}</div>
      </div>
      ${r.readers_count ? `<span style="font-size: 10px; opacity: 0.5; flex-shrink: 0;">${r.readers_count}</span>` : ''}
    `;
    box.appendChild(item);
  });
  box.style.display = '';
}

function hideSearchResults() {
  const box = $('[data-field="catalog-search-results"]', root());
  if (box) box.style.display = 'none';
}

export function catalogSearchClear() {
  const input = $('[data-field="catalog-search-input"]', root());
  if (input) input.value = '';
  const btn = $('[data-action="catalog-search-clear"]', root());
  if (btn) btn.style.display = 'none';
  hideSearchResults();
}

// ── Tabs ────────────────────────────────────────────────────
export function catalogTab(name) {
  const tabs = $$('[data-action="catalog-tab"]', root());
  tabs.forEach(t => {
    const active = t.dataset.tab === name;
    if (active) {
      t.dataset.active = 'true';
      t.style.background = '#1C1A16';
      t.style.color = '#F7F2EA';
      t.style.border = 'none';
      t.style.fontWeight = '500';
    } else {
      delete t.dataset.active;
      t.style.background = 'transparent';
      t.style.color = 'color-mix(in srgb, var(--ink) 65%, transparent)';
      t.style.border = '0.5px solid color-mix(in srgb, var(--ink) 12%, transparent)';
      t.style.fontWeight = '';
    }
  });
  // Filter behavior — Stage 6.2-де placeholder (toast)
  if (name === 'all') return;
  toast(`📚 "${name}" — фильтр жалғасы Stage 6.3-те`);
}

// ── Genre / Author / Filter actions ─────────────────────────
// Stage 6.3: жанр беті / автор беті — нақты pages
export function openGenre(slug) {
  if (!slug) return;
  state.genre = { slug, sort: 'popular', offset: 0, books: [] };
  show('genre');
  // Async load кейін show() router pattern сай (catalog v2 секілді)
  setTimeout(() => loadGenrePage(slug, 'popular'), 0);
}

export function openAuthor(slug) {
  if (!slug) return;
  state.author = { slug };
  show('author');
  setTimeout(() => loadAuthorPage(slug), 0);
}

export function catalogBack() {
  show('catalog');
}

// ── Genre page ──────────────────────────────────────────────
const _SORT_LABELS_KK = {
  popular:  'Танымал',
  new:      'Жаңа',
  rating:   'Рейтинг',
  alphabet: 'Әліпби',
};

function renderGenreHero(g) {
  if (!g) return;
  const setG = (name, value) => {
    const el = genreRoot().querySelector(`[data-field="${name}"]`);
    if (el) el.textContent = value;
  };
  setG('genre-name', g.name || '—');
  setG('genre-count', (g.total_count || 0).toLocaleString('kk-KZ').replace(/,/g, ' '));
  setG('genre-readers', (g.readers_count || 0).toLocaleString('kk-KZ').replace(/,/g, ' '));
  const desc = genreRoot().querySelector('[data-field="genre-description"]');
  if (desc) {
    if (g.description) {
      desc.textContent = g.description;
      desc.style.display = '';
    } else {
      desc.style.display = 'none';
    }
  }
  // Icon — slug бойынша map (founder fix: бұрын palette index болатын)
  const style = getGenreStyle(g.slug);
  const icon = genreRoot().querySelector('[data-field="genre-icon"]');
  if (icon) {
    icon.className = `ti ${style.icon_ti}`;
    icon.style.color = style.icon_color;
  }
  // Hero icon контейнер background — slug-сай tone
  const iconBox = icon?.parentElement;
  if (iconBox) {
    iconBox.style.background = style.bg;
    iconBox.style.border = `0.5px solid ${style.border}`;
  }
}

function renderTopAuthors(list) {
  const wrap = genreRoot().querySelector('[data-field="top-authors-list"]');
  if (!wrap) return;
  wrap.innerHTML = '';
  (list || []).forEach(a => {
    const btn = document.createElement('button');
    btn.dataset.action = 'open-author';
    btn.dataset.author = a.slug;
    btn.style.cssText = 'flex: 0 0 100px; background: var(--card); border-radius: 12px; padding: 10px 8px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); cursor: pointer; text-align: center;';
    btn.innerHTML = `
      <div style="width: 40px; height: 40px; border-radius: 50%; background: ${esc(a.color_gradient)}; color: var(--bg); display: flex; align-items: center; justify-content: center; font-family: Georgia, serif; font-size: 14px; font-weight: 500; margin: 0 auto 6px;">${esc(a.initials || '?')}</div>
      <div style="font-family: Georgia, serif; font-size: 11px; font-weight: 500; line-height: 1.2; margin-bottom: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(a.name || '')}</div>
      <div style="font-size: 9px; opacity: 0.55;">${a.books_count || 0} кітап</div>
    `;
    wrap.appendChild(btn);
  });
}

function renderGenreSortPills(active) {
  genreRoot().querySelectorAll('[data-action="genre-sort"]').forEach(p => {
    const isActive = p.dataset.sort === active;
    if (isActive) {
      p.dataset.active = 'true';
      p.style.background = '#1C1A16';
      p.style.color = '#F7F2EA';
      p.style.border = 'none';
      p.style.fontWeight = '500';
    } else {
      delete p.dataset.active;
      p.style.background = 'transparent';
      p.style.color = 'color-mix(in srgb, var(--ink) 65%, transparent)';
      p.style.border = '0.5px solid color-mix(in srgb, var(--ink) 12%, transparent)';
      p.style.fontWeight = '';
    }
  });
}

function renderGenreBook(b) {
  const btn = document.createElement('button');
  if (b.slug) {
    btn.dataset.action = 'open-book';
    btn.dataset.slug = b.slug;
  }
  btn.dataset.bookId = b.book_id ?? '';
  btn.style.cssText = 'display: flex; align-items: center; gap: 12px; padding: 12px; background: var(--card); border-radius: 14px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); cursor: pointer; text-align: left; width: 100%;';
  let meta = '';
  if (b.rating) {
    const stars = '<i class="ti ti-star"></i>'.repeat(5);
    meta = `<div style="display: flex; gap: 1px; color: var(--gold); font-size: 9px;">${stars}</div><span style="opacity: 0.55;">${b.rating}</span>`;
    if (b.readers_count) meta += `<span style="opacity: 0.3;">·</span><span style="opacity: 0.55;">${b.readers_count} оқырман</span>`;
  } else if (b.readers_count >= 50) {
    meta = `<span style="display: inline-flex; align-items: center; gap: 3px; padding: 2px 7px; background: rgba(234,88,12,0.1); color: #c2410c; border-radius: 999px; font-weight: 500;">🔥 ${b.readers_count}</span><span style="opacity: 0.5;">оқырман</span>`;
  } else if (b.readers_count) {
    meta = `<span style="opacity: 0.55;">${b.readers_count} оқырман</span>`;
  }
  const yearLine = [b.author || '', b.year || ''].filter(Boolean).join(' · ');
  btn.innerHTML = `
    <div style="width: 46px; height: 68px; background: ${esc(b.cover_gradient || 'linear-gradient(135deg, #8B5E34 0%, #6B4423 100%)')}; border-radius: 4px; flex-shrink: 0; position: relative; overflow: hidden;">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-family: Georgia, serif; font-size: 8px; font-style: italic; color: var(--bg); padding: 0 3px; text-align: center;">${esc(b.cover_text || b.title || '')}</div>
    </div>
    <div style="flex: 1; min-width: 0;">
      <div style="font-family: Georgia, serif; font-size: 14px; font-weight: 500; line-height: 1.2; margin-bottom: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(b.title || '—')}</div>
      <div style="font-size: 11px; opacity: 0.6; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(yearLine)}</div>
      <div style="display: flex; align-items: center; gap: 6px; font-size: 10px;">${meta}</div>
    </div>
    <i class="ti ti-chevron-right" style="font-size: 14px; opacity: 0.3; flex-shrink: 0;"></i>
  `;
  return btn;
}

function renderGenreBooks(books, append) {
  const wrap = genreRoot().querySelector('[data-field="genre-books-list"]');
  if (!wrap) return;
  if (!append) wrap.innerHTML = '';
  (books || []).forEach(b => wrap.appendChild(renderGenreBook(b)));
  if ((books || []).length === 0 && !append) {
    wrap.innerHTML = '<div style="padding: 20px 12px; background: color-mix(in srgb, var(--ink) 2%, transparent); border-radius: 12px; border: 0.5px dashed color-mix(in srgb, var(--ink) 8%, transparent); text-align: center; font-size: 12px; opacity: 0.55;">Бұл жанрда әзірге кітап жоқ.</div>';
  }
}

// Loading skeleton — sort басқанда optimistic UI
function renderGenreBooksSkeleton() {
  const wrap = genreRoot().querySelector('[data-field="genre-books-list"]');
  if (!wrap) return;
  wrap.innerHTML = '';
  // 5 placeholder pulsing card
  for (let i = 0; i < 5; i++) {
    const card = document.createElement('div');
    card.style.cssText = 'display: flex; align-items: center; gap: 12px; padding: 12px; background: var(--card); border-radius: 14px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); opacity: 0.5; animation: paraqta-pulse 1.2s ease-in-out infinite;';
    card.innerHTML = `
      <div style="width: 46px; height: 68px; background: color-mix(in srgb, var(--ink) 8%, transparent); border-radius: 4px; flex-shrink: 0;"></div>
      <div style="flex: 1; min-width: 0;">
        <div style="height: 12px; background: color-mix(in srgb, var(--ink) 10%, transparent); border-radius: 4px; margin-bottom: 6px; width: 70%;"></div>
        <div style="height: 10px; background: color-mix(in srgb, var(--ink) 6%, transparent); border-radius: 4px; margin-bottom: 6px; width: 50%;"></div>
        <div style="height: 9px; background: color-mix(in srgb, var(--ink) 5%, transparent); border-radius: 4px; width: 40%;"></div>
      </div>
    `;
    wrap.appendChild(card);
  }
  // Ensure pulse keyframe injected once
  if (!document.getElementById('paraqta-pulse-style')) {
    const style = document.createElement('style');
    style.id = 'paraqta-pulse-style';
    style.textContent = '@keyframes paraqta-pulse { 0%, 100% { opacity: 0.5; } 50% { opacity: 0.8; } }';
    document.head.appendChild(style);
  }
}

function renderGenreLoadMore(data) {
  const wrap = genreRoot().querySelector('[data-field="genre-load-more-wrap"]');
  const span = genreRoot().querySelector('[data-field="genre-remaining"]');
  if (!wrap || !span) return;
  if (data.has_more) {
    const remaining = (data.genre?.total_count || 0) - (state.genre.offset + (data.books?.length || 0));
    span.textContent = remaining > 0 ? remaining.toLocaleString('kk-KZ').replace(/,/g, ' ') : '';
    wrap.style.display = '';
  } else {
    wrap.style.display = 'none';
  }
}

// loadGenrePage — `_genreLoading` guard алып тастадым: cold initial load
// 15-20s болғанда user sort басу → fetch fire-этпейтін race condition бар
// еді. Concurrent fetches идемпотентті — соңғы response отображается.
// Optimistic UI (pill + skeleton) sort feedback-ті дереу қамтамасыз етеді.
let _genreReqId = 0;
export async function loadGenrePage(slug, sort = 'popular', append = false) {
  const myReqId = ++_genreReqId;
  try {
    const offset = append ? state.genre.offset : 0;
    const url = `/api/catalog/genre/${encodeURIComponent(slug)}?sort=${sort}&offset=${offset}&limit=20`;
    const data = await api(url);
    // Stale response guard — басқа load fire-этсе, бұл результатты тастаймыз.
    if (myReqId !== _genreReqId) return;
    state.genre = {
      slug,
      sort,
      offset: offset + (data.books?.length || 0),
      books: append ? [...state.genre.books, ...(data.books || [])] : (data.books || []),
    };
    if (!append) {
      renderGenreHero(data.genre);
      renderTopAuthors(data.top_authors);
      renderGenreSortPills(sort);
    }
    renderGenreBooks(data.books, append);
    renderGenreLoadMore(data);
  } catch (e) {
    console.error('loadGenrePage failed', e);
    if (myReqId === _genreReqId) toast('Жанр бетін жүктеу мүмкін болмады');
  }
}

export function genreSort(sort) {
  if (!state.genre.slug) return;
  // Optimistic UI — sort pill бірден switch + books skeleton (founder ескерту:
  // user fetch күтуді "сынған" деп ойлайды; visible feedback керек).
  renderGenreSortPills(sort);
  renderGenreBooksSkeleton();
  loadGenrePage(state.genre.slug, sort, false);
}

export function genreLoadMore() {
  if (!state.genre.slug) return;
  loadGenrePage(state.genre.slug, state.genre.sort, true);
}

export function catalogSortOptions() {
  // Sort pill бар — нақты модал ашпаймыз; placeholder.
  toast(`📑 Сорт: ${_SORT_LABELS_KK[state.genre.sort] || 'Танымал'}`);
}

// ── Author page ─────────────────────────────────────────────
function renderAuthorHero(a) {
  if (!a) return;
  const setA = (name, value) => {
    const el = authorRoot().querySelector(`[data-field="${name}"]`);
    if (el) el.textContent = value;
  };
  setA('author-avatar', a.initials || '?');
  setA('author-name', a.name || '—');
  setA('author-books-count', a.books_count || 0);
  setA('author-readers-count', (a.readers_count || 0).toLocaleString('kk-KZ').replace(/,/g, ' '));
  setA('author-pages-count', (a.pages_count || 0).toLocaleString('kk-KZ').replace(/,/g, ' '));

  const yearsEl = authorRoot().querySelector('[data-field="author-years"]');
  if (yearsEl) {
    if (a.years) { yearsEl.textContent = a.years; yearsEl.style.display = ''; }
    else yearsEl.style.display = 'none';
  }
  const bioEl = authorRoot().querySelector('[data-field="author-bio"]');
  if (bioEl) {
    if (a.bio) { bioEl.textContent = a.bio; bioEl.style.display = ''; }
    else bioEl.style.display = 'none';
  }
}

function renderAuthorBook(b) {
  const btn = document.createElement('button');
  if (b.slug) {
    btn.dataset.action = 'open-book';
    btn.dataset.slug = b.slug;
  }
  btn.dataset.bookId = b.book_id ?? '';
  btn.style.cssText = 'display: flex; align-items: center; gap: 12px; padding: 12px; background: var(--card); border-radius: 14px; border: 0.5px solid color-mix(in srgb, var(--ink) 6%, transparent); cursor: pointer; text-align: left; width: 100%;';
  const topBadge = b.is_top
    ? '<span style="font-size: 9px; padding: 1px 6px; background: rgba(234,88,12,0.12); color: #c2410c; border-radius: 999px; font-weight: 500;">🔥 топ</span>'
    : '';
  const metaParts = [];
  if (b.year) metaParts.push(b.year);
  if (b.genre) metaParts.push(b.genre);
  if (b.pages) metaParts.push(`${b.pages} бет`);
  const metaLine = metaParts.join(' · ');
  btn.innerHTML = `
    <div style="width: 50px; height: 74px; background: ${esc(b.cover_gradient || 'linear-gradient(135deg, #8B5E34 0%, #6B4423 100%)')}; border-radius: 4px; flex-shrink: 0; position: relative; overflow: hidden;">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-family: Georgia, serif; font-size: 9px; font-style: italic; color: var(--bg); padding: 0 3px; text-align: center;">${esc(b.cover_text || b.title || '')}</div>
    </div>
    <div style="flex: 1; min-width: 0;">
      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 2px;">
        <div style="font-family: Georgia, serif; font-size: 15px; font-weight: 500; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(b.title || '—')}</div>
        ${topBadge}
      </div>
      <div style="font-size: 11px; opacity: 0.55; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(metaLine)}</div>
      <div style="font-size: 10px; opacity: 0.6;">${b.readers_count ? (b.is_top ? `<span style="color: #c2410c; font-weight: 500;">${b.readers_count}</span> оқырман` : `${b.readers_count} оқырман`) : '—'}</div>
    </div>
    <i class="ti ti-chevron-right" style="font-size: 14px; opacity: 0.3; flex-shrink: 0;"></i>
  `;
  return btn;
}

function renderAuthorBooks(books) {
  const wrap = authorRoot().querySelector('[data-field="author-books-list"]');
  if (!wrap) return;
  wrap.innerHTML = '';
  (books || []).forEach(b => wrap.appendChild(renderAuthorBook(b)));
  if ((books || []).length === 0) {
    wrap.innerHTML = '<div style="padding: 20px 12px; background: color-mix(in srgb, var(--ink) 2%, transparent); border-radius: 12px; border: 0.5px dashed color-mix(in srgb, var(--ink) 8%, transparent); text-align: center; font-size: 12px; opacity: 0.55;">Әзірге кітап жоқ.</div>';
  }
}

function renderAuthorReaders(data) {
  const avatars = authorRoot().querySelector('[data-field="readers-avatars"]');
  const summary = authorRoot().querySelector('[data-field="readers-summary"]');
  if (!avatars || !summary) return;
  avatars.innerHTML = '';
  const preview = data.readers_preview || [];
  preview.forEach((r, i) => {
    const av = document.createElement('div');
    const ml = i === 0 ? '' : 'margin-left: -8px;';
    av.style.cssText = `width: 32px; height: 32px; border-radius: 50%; background: ${r.color_gradient}; color: var(--bg); display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 500; border: 2px solid #F7F2EA; ${ml}`;
    av.textContent = r.initials || '?';
    avatars.appendChild(av);
  });
  const total = data.author?.readers_count || 0;
  const more = total - preview.length;
  if (more > 0) {
    const overflow = document.createElement('div');
    overflow.style.cssText = 'width: 32px; height: 32px; border-radius: 50%; background: color-mix(in srgb, var(--ink) 8%, transparent); color: var(--ink); display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 500; border: 2px solid #F7F2EA; margin-left: -8px;';
    overflow.textContent = `+${more}`;
    avatars.appendChild(overflow);
  }
  const totalFmt = total.toLocaleString('kk-KZ').replace(/,/g, ' ');
  const now = data.readers_now_count || 0;
  summary.innerHTML = `
    <strong style="font-weight: 500; color: var(--ink);">${totalFmt} оқырман</strong> бұл авторды парақтаған.
    ${now > 0 ? `<br/>Олардың <strong style="font-weight: 500; color: #c2410c;">${now}</strong>-сі қазір оқып жатыр.` : ''}
  `;
}

let _authorLoading = false;
export async function loadAuthorPage(slug) {
  if (_authorLoading) return;
  _authorLoading = true;
  try {
    const data = await api(`/api/catalog/author/${encodeURIComponent(slug)}`);
    renderAuthorHero(data.author);
    renderAuthorBooks(data.books);
    renderAuthorReaders(data);
  } catch (e) {
    console.error('loadAuthorPage failed', e);
    toast('Автор бетін жүктеу мүмкін болмады');
  } finally {
    _authorLoading = false;
  }
}

export function authorShare() {
  const slug = state.author.slug;
  const url = `${window.location.origin}/#author/${slug || ''}`;
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(url).then(
      () => toast('🔗 Сілтеме көшірілді'),
      () => toast('Көшіру мүмкін болмады'),
    );
  } else {
    toast(url);
  }
}

export function catalogFilter() {
  toast('🔍 Сүзгі модалі — Stage 6.3');
}

export function openAllAuthors() { toast('Барлық авторлар — Stage 6.3'); }
export function openAllFeatured() { toast('Барлық featured — Stage 6.3'); }
export function openAllNew() { toast('Барлық жаңалар — Stage 6.3'); }

// ── Submit modal ────────────────────────────────────────────
function ensureGenreOptions() {
  const sel = $('[data-field="submit-genre"]', document);
  if (!sel || sel.dataset.populated) return;
  const genres = state.data?.genres || [];
  if (genres.length === 0) return;
  genres.forEach(g => {
    const opt = document.createElement('option');
    opt.value = g.slug;
    opt.textContent = g.name || g.slug;
    sel.appendChild(opt);
  });
  sel.dataset.populated = '1';
}

export function openCatalogSubmitModal() {
  if (!window.currentUser) {
    toast('Алдын кіруіңіз керек');
    return;
  }
  const modal = document.getElementById('submitBookModal');
  if (!modal) return;
  ensureGenreOptions();
  // Reset
  ['submit-title', 'submit-author', 'submit-pages', 'submit-description'].forEach(f => {
    const el = $(`[data-field="${f}"]`, document);
    if (el) el.value = '';
  });
  const sel = $('[data-field="submit-genre"]', document);
  if (sel) sel.value = '';
  $('[data-field="submit-dup-warn"]', document).style.display = 'none';
  $('[data-field="submit-error"]', document).style.display = 'none';

  modal.style.display = 'flex';
  // Type-ahead duplicate check on title
  const titleInput = $('[data-field="submit-title"]', document);
  if (titleInput && !titleInput.dataset.dupBound) {
    titleInput.dataset.dupBound = '1';
    let dupTimer = null;
    titleInput.addEventListener('input', () => {
      if (dupTimer) clearTimeout(dupTimer);
      const v = titleInput.value.trim();
      if (v.length < 2) {
        $('[data-field="submit-dup-warn"]', document).style.display = 'none';
        return;
      }
      dupTimer = setTimeout(async () => {
        try {
          const data = await api(`/api/catalog/search?q=${encodeURIComponent(v)}`);
          const exact = data.results?.find(r => (r.title || '').toLowerCase() === v.toLowerCase());
          $('[data-field="submit-dup-warn"]', document).style.display = exact ? '' : 'none';
        } catch (_) {}
      }, 400);
    });
  }
}

export function closeCatalogSubmitModal() {
  const modal = document.getElementById('submitBookModal');
  if (modal) modal.style.display = 'none';
}

export async function submitBookV2() {
  const title = $('[data-field="submit-title"]', document)?.value.trim();
  const author = $('[data-field="submit-author"]', document)?.value.trim();
  const genre = $('[data-field="submit-genre"]', document)?.value || '';
  const pages = parseInt($('[data-field="submit-pages"]', document)?.value, 10) || 0;
  const description = $('[data-field="submit-description"]', document)?.value.trim();
  const errEl = $('[data-field="submit-error"]', document);
  errEl.style.display = 'none';

  if (!title || !author) {
    errEl.textContent = 'Атау және автор міндетті';
    errEl.style.display = '';
    return;
  }

  try {
    const res = await api('/api/catalog/submit', {
      method: 'POST',
      body: JSON.stringify({ title, author, genre, pages, description }),
    });
    if (res?.ok) {
      closeCatalogSubmitModal();
      toast('✓ ' + (res.message || 'Жіберілді'));
    } else {
      errEl.textContent = 'Жіберу мүмкін болмады';
      errEl.style.display = '';
    }
  } catch (e) {
    errEl.textContent = (e?.message || 'Жіберу мүмкін болмады');
    errEl.style.display = '';
  }
}

// ── «Платформада оқи аласың» виджеті ────────────────────────
// Founder (2026-08-18): кітапхана бетінде қордағы кітаптар БІРДЕН көрініп
// тұрсын. Басқанда сөреге қосылады да (файл автоматты тіркеледі), батырма
// «✓ Сөреңде — оқи бер» болып өзгереді.
// Жанр → бет бөлімі. Жаңа жанр қосылса — осында бір жол қосу жеткілікті
// (index.html-де сол `key` атымен бөлім болуы керек).
const GENRE_SHELF = [
  ['ertegi', 'Қазақ халық ертегілері'],
  ['eng',    'Ағылшынша оқу'],
];

async function loadReadableBooks() {
  let books = [];
  try {
    const d = await api('/api/library/books');
    books = (d && d.books) || [];
  } catch (_) { /* қонақ/қате — виджет жай көрінбейді */ }
  // ❗26.08: бет «484 кітап» деп уәде беретін де, адам ашылмайтын карточкаға
  // тіреліп «кітап ашылмайды» деп шағымданатын. Енді бас жолда ШЫНЫ тұрады:
  // қаншасы толық оқылады. Уәде мен шындық бір жерде.
  try {
    const el = document.querySelector('[data-field="catalog-readable-note"]');
    if (el && books.length) {
      el.innerHTML = `<b>${books.length}</b> кітапты осында, тегін, толық оқисың`;
      el.style.display = '';
    }
  } catch (_) {}
  // Жанрлар БӨЛЕК бөлімде. 82 ертегі жалпы тізімге қосылса, қалған
  // кітаптар солардың арасында көрінбей қалады (әрі тізім шексіз ұзын).
  const used = new Set();
  GENRE_SHELF.forEach(([key, genre]) => {
    const list = books.filter(b => (b.genre || '') === genre);
    list.forEach(b => used.add(b.id));
    fillShelf(key, list);
  });
  fillShelf('readable', books.filter(b => !used.has(b.id)));
  // 25.09: «Кітап қолыңда ма? → Кітабым жоқ» деп келсе — тегін оқылатын бөлімге апарамыз.
  try {
    if (sessionStorage.getItem('pq_cat_readable')) {
      sessionStorage.removeItem('pq_cat_readable');
      const s = document.querySelector('#pg-catalog [data-section="readable"]')
             || document.querySelector('#pg-catalog [data-section="ertegi"]');
      if (s) setTimeout(() => s.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    }
  } catch (_) {}
}

// Көлденең жолақ ↔ торкөз. 82 ертегіні жолақпен шолу мүмкін емес
// (founder: «тек скролл арқылы көре алады, ыңғайсыздау») — сондықтан
// әр бөлімнің саны басылатын батырма болады: бәрі бірден көрінеді.
const CAROUSEL = 'display:flex;gap:13px;overflow-x:auto;padding:2px 0 4px;scrollbar-width:none';
const GRID = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(104px,1fr));' +
             'gap:16px 11px;padding:2px 0 4px;overflow:visible';
const _expanded = {};

function shelfToggle(key, list, total) {
  const sec = root().querySelector(`[data-section="${key}"]`);
  if (!sec) return;
  let btn = sec.querySelector('[data-field="shelf-more"]');
  if (!btn) {
    btn = document.createElement('button');
    btn.setAttribute('data-field', 'shelf-more');
    btn.style.cssText = 'display:block;width:100%;margin-top:12px;padding:9px;border:none;' +
      'border-radius:11px;background:color-mix(in srgb,var(--ac) 9%,transparent);' +
      'color:var(--ac);font-family:inherit;font-size:12.5px;font-weight:600;cursor:pointer';
    sec.appendChild(btn);
    btn.onclick = () => {
      _expanded[key] = !_expanded[key];
      applyShelfMode(key, list, total);
    };
  }
  applyShelfMode(key, list, total);
}

function applyShelfMode(key, list, total) {
  const open = !!_expanded[key];
  list.style.cssText = open ? GRID : CAROUSEL;
  // жолақта карточка ені бекітілген, торкөзде — созылмалы
  list.querySelectorAll('button').forEach(b => {
    b.style.flex = open ? 'unset' : '0 0 118px';
    const t = b.querySelector('[data-title]');
    if (t) {
      t.style.whiteSpace = open ? 'normal' : 'nowrap';
      t.style.fontSize = open ? '12.5px' : '13.5px';
    }
    b.style.width = open ? '100%' : '118px';
    const cov = b.firstElementChild;
    if (cov) { cov.style.width = open ? '100%' : '118px'; cov.style.height = open ? '150px' : '170px'; }
  });
  const sec = root().querySelector(`[data-section="${key}"]`);
  const btn = sec && sec.querySelector('[data-field="shelf-more"]');
  if (btn) btn.textContent = open ? '↑ Жию' : `Барлығын көру (${total}) ↓`;
}

function fillShelf(key, books) {
  const sec = root().querySelector(`[data-section="${key}"]`);
  const list = root().querySelector(`[data-field="${key}-list"]`);
  if (!sec || !list) return;
  if (!books.length) { sec.style.display = 'none'; return; }
  sec.style.display = '';
  const cnt = root().querySelector(`[data-field="${key}-count"]`);
  if (cnt) cnt.textContent = `${books.length} кітап`;
  list.innerHTML = '';
  books.forEach(b => {
    const btn = document.createElement('button');
    btn.style.cssText = 'flex: 0 0 118px; width: 118px; background: none; border: none; padding: 0; cursor: pointer; text-align: left;';
    const cover = b.cover_url
      ? `<img src="${esc(b.cover_url)}" alt="" loading="lazy" style="width: 100%; height: 100%; object-fit: cover; display: block;">`
      : `<div style="font-family: Georgia, serif; font-style: italic; font-size: 13px; color: #F3E9D6; text-align: center; line-height: 1.2; padding: 10px;">${esc(b.title)}</div>`;
    btn.innerHTML = `
      <div style="width: 118px; height: 170px; background: linear-gradient(135deg, #3E4E3A 0%, #24301F 100%); border-radius: 9px; overflow: hidden; box-shadow: 0 8px 20px -10px rgba(28,26,22,.45); display: flex; align-items: center; justify-content: center;">${cover}</div>
      <div style="font-family: Georgia, serif; font-size: 13.5px; font-weight: 500; margin-top: 8px; line-height: 1.15; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${esc(b.title)}</div>
      <div style="font-size: 11px; opacity: 0.6; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${esc(b.author || '')}</div>
      <div style="font-size: 10px; opacity: .5;">${b.est_pages ? b.est_pages + ' бет · ' : ''}тегін</div>
      <div class="cat-rtag ok">📖 мұнда оқисың</div>`;
    // Founder: бірден сөреге кетпей, АЛДЫМЕН кітап беті ашылсын — аннотация,
    // пікірлер, мұқаба. Сөреге қосу сол жерден.
    btn.onclick = () => openBookPage(b.slug || '');
    list.appendChild(btn);
  });
  // Торкөзде атау бір жолға сыймайды — қысқартуды алып, 2 жолға рұқсат
  list.querySelectorAll('button > div:nth-child(2)').forEach(t => {
    t.dataset.title = '1';
  });
  shelfToggle(key, list, books.length);
}

// ── Main entry ──────────────────────────────────────────────
let _loading = false;
export async function loadCatalogV2() {
  if (_loading) return;
  _loading = true;
  try {
    const data = await api('/api/catalog/v2');
    state.data = data;
    renderHero(data);
    renderGenres(data);
    renderAuthors(data);
    renderFeatured(data);
    renderNewBooks(data);
    loadReadableBooks();   // «Платформада оқи аласың» виджеті (library_books)
    setupSearch();
    // Genre dropdown — modal үшін
    ensureGenreOptions();
  } catch (e) {
    console.error('loadCatalogV2 failed', e);
    toast('Кітапхана жүктелмеді');
  } finally {
    _loading = false;
  }
}

// ── Legacy exports (router/events/landing) — safe no-ops in v2 DOM ─
// loadGenres + loadCatalog бар router.js-те шақырылады. Catalog v2-да
// олар бір ғана loadCatalogV2() орнатады.
export async function loadCatalog() { return loadCatalogV2(); }
export async function loadGenres() { /* v2-да loadCatalogV2 ішінде */ }

let _legacyGenre = null;
export function setCatalogGenre(slug) {
  _legacyGenre = slug;
}

export function filterGenre(slug) {
  // landing-тен немесе catalog-та шақырылуы мүмкін.
  // V2-де нақты фильтр Stage 6.3-те — қазір тек navigation.
  _legacyGenre = slug;
  if (slug) openGenre(slug);
}

export function catalogGoPage(_p) {
  // Pagination v2-да жоқ — placeholder.
}
